// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__39U5D","footer":"ReportModalFilter_footer__3T7vO"};